// main.jsx - Browser entry. Hydrates when the page was prerendered, mounts fresh
// otherwise, so the same bundle serves both the static HTML build and the plain
// SPA build without a flag.

import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import App from "./App.jsx";
import { ToastProvider } from "./ui/kit.jsx";
import { watchInstallPrompt } from "./lib/pwa.js";
import "./styles/index.css";

// Chrome fires its install event once, within a second or so of load, and never
// again. Catching it here rather than in the dashboard means the offer is still
// available several screens later, when somebody goes looking for it.
watchInstallPrompt();

const tree = (
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>
);

const container = document.getElementById("root");

if (container.hasChildNodes()) hydrateRoot(container, tree);
else createRoot(container).render(tree);
